import { GetPJAsync } from '@/api/pieceJointes/index';
import { insertPieceJointe, updatePieceJointe } from '@/services/piecesJointes/savePiecesJointes';
import { MODULE_CLIENT, PIECE_JOINTE_TYPE_LOGO } from '@/configuration/pieceJointeConf';

export default async function savePiecesjointeClient(piecesJointes, clientId) {
  if (!piecesJointes || !piecesJointes.length) return;
  const logo = piecesJointes.find(pj => pj.placeType === PIECE_JOINTE_TYPE_LOGO);
  if (!logo) {
    await insertPieceJointe(piecesJointes, clientId, MODULE_CLIENT);
    return;
  }
  const pjClient = (await GetPJAsync(clientId)).data;
  const pjConservees = pjClient.filter(pj => pj.placeType !== PIECE_JOINTE_TYPE_LOGO);
  if (pjConservees.length === pjClient.length) {
    await insertPieceJointe(piecesJointes, clientId, MODULE_CLIENT);
    return;
  }
  await updatePieceJointe([...pjConservees, ...piecesJointes], clientId, MODULE_CLIENT);
}
